import React, { Component } from 'react';
import { Header, List, Table } from 'semantic-ui-react';

export default class ProgressReportsPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Progress report 1" />
        <p>
          <b>Due Date:</b>
          3/1/22
        </p>

        <p>
          This is your first checkpoint for the project. The goal is to focus on prototyping or piloting the
          core element of your research idea. Reflect on your abstract and its core insight or question.
        </p>

        <p>
          What is the pilot study or prototype that would most clearly examine it? Do not spend much time
          working on aspects of the project that are orthogonal to your research question. For example, if
          you are testing a new method of authenticating based on dancing, focus on implementing the interaction
          and recognizing the user, not the entire underlying infrastructure of connecting your new authentication
          technique to an end-point (e.g., by trying to root your phone and install a custom ROM that allows to
          override existing authentication options).
        </p>

        <p>
          As another example, if you are studying whether people think that online comments that contain self
          disclosure (e.g., "I'm scared of Sauvik’s eyebrows") are more likely to occur on ephemeral or permanently
          archived social media, focus on gathering the status updates for the study and analyzing the results from
          a pilot run: don't worry about the details of your labeling interface.
        </p>

        <Header as="h2" content="Deliverable" />
        <p>
          If you are creating a system, the deliverable is a basic working prototype of your research idea. It does
          not need to be polished, but you should have the basic idea at a functional prototype level.
        </p>

        <p>
          If you are running a study, the deliverable is pilot results from at least five people who ran through an
          early version of your study, including a first round of data analysis.
        </p>

        <p>
          Submit any relevant materials, including a one-page document describing your project status, goals and a rough plan
          for the rest of the semester (including what you plan to do by the second progress report). We'll also be using the
          last 30 minutes of class to show off our projects to each other, so bring any demo or study materials you've got.
        </p>

        <Header as="h3" content="Grading" />
        <p>
          You can earn up to 13 points for the assignment along the following three dimensions: depth, focus and plan.
          Refer to the following rubric for more specific information:
        </p>

        <Table definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>Insufficient</Table.HeaderCell>
              <Table.HeaderCell>Adequate</Table.HeaderCell>
              <Table.HeaderCell>Proficient</Table.HeaderCell>
              <Table.HeaderCell>Mastery</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>Depth (8 pts)</Table.Cell>
              <Table.Cell>
                2: The system or study is too thin to evaluate the research question. Critical components are missing.
              </Table.Cell>
              <Table.Cell>
                4: The system or study has a basic pilot/prototype, but it is only barely at a depth to point to next
                steps for the research.
              </Table.Cell>
              <Table.Cell>
                6: The system or study has a pilot/prototype that exercises the main research idea, provides evidence
                of its final feasability, and points to next steps for the research.
              </Table.Cell>
              <Table.Cell>
                8: The system or study has struck at the core of the idea and demonstrates clear directions for the
                research.
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                Focus (3 pts)
              </Table.Cell>
              <Table.Cell>
                1: Too diffuse: attempting to prototype/pilot too much of the idea at once meant that the core question
                was largely left unexplored.
              </Table.Cell>
              <Table.Cell>
                2: The system or study explores the main question or insight, but also spent significant time on less
                critical aspects of the research.
              </Table.Cell>
              <Table.Cell colSpan={2}>
                3: The system or study focuses directly on the most important parts of the research question.
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                Plan (2 pts)
              </Table.Cell>
              <Table.Cell>
                1: Plan is underspecified, not ambitious enough, or too ambitious.
              </Table.Cell>
              <Table.Cell>
                2: Plan clearly details the goals for Round Two and a realistic timeline to achieve them.
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <a name="2" />
        <Header as="h1" content="Progress report 2" />
        <p>
          <b>Due Date:</b>
          3/31/22
        </p>

        <p>
          We are nearing the end of the semester, so it's time to start showing off your best stuff. This is your
          last checkpoint before the final project presentations. The goal is to have the core element of your research
          project complete. If it's a system, that means that the core research functionality should be implemented,
          and (perhaps with an additional coat of paint to come soon) ready for an evaluation. If it's a study, you
          should have your final materials complete, the study should have at least ten participants so far, and you
          should have a first statistical/qualitative analysis of your data complete. If it's a study, it is OK for
          this version to have null results as long as you also have an idea of how to proceed.
        </p>
        <p>
          We'll also be using the last 30 minutes of class to show off our projects to each other, so bring any demo,
          study materials, or data that you've got.
        </p>

        <Header as="h2" content="Deliverable" />
        <p>
          On Canvas, submit relevant project materials and a one page document. In this document, describe your project status,
          your goals to accomplish between now and the final project presentations, and a rough plan for doing so.
        </p>

        <Header as="h2" content="Grading" />
        <p>
          The rubric is the same as for the first progress report.
        </p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/group-project-assignments/progress-reports-page.js